import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { LabelPicker, } from '@tribeplatform/react-ui-kit/LabelPicker';
export function FormLabelPicker({ name, validation, label, helperText, value: fieldValue, onChange: fieldOnChange, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, defaultValue: [], render: ({ field: { onChange, value }, fieldState: { error, invalid }, }) => {
            return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(LabelPicker, { ...rest, invalid: invalid, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value, onChange: value => {
                                    onChange(value);
                                    if (typeof fieldOnChange === 'function') {
                                        fieldOnChange(value);
                                    }
                                } }, void 0), _jsx(FormControl.Meta, { ...{
                                    helperText,
                                    invalid,
                                    error: error === null || error === void 0 ? void 0 : error.message,
                                } }, void 0)] }, void 0)] }, void 0));
        } }, void 0));
}
//# sourceMappingURL=FormLabelPicker.js.map